import React from 'react';
import { observer } from 'mobx-react';
import { useTheme } from 'styled-components';
import get from 'lodash/get';

import { SmallText } from '@ui-library/typography';
import { Flex } from '@ui-library/flex';

import { useAccountManagementStore } from '../store';

interface AccountOptionsProps {
  accountId: string;
}

export const AccountOptions: React.FC<AccountOptionsProps> = observer(({ accountId }) => {
  const { findAccountById, compatibleAccountDefinitions } = useAccountManagementStore();
  const accountDetails = findAccountById(accountId);

  if (!accountDetails || compatibleAccountDefinitions.length === 0) {
    return null;
  }

  const accountDefinition = compatibleAccountDefinitions.find(
    (accountDef) => accountDef.name === accountDetails?.accountDefinitionName,
  );
  const viewOptions = accountDefinition!.uiConfig.form.fields.filter((field) =>
    field.key.includes('options'),
  );

  const theme = useTheme();

  return (
    <Flex flexDirection="row" gap="4px" className="m-t-sm">
      {viewOptions.map((option, index) => (
        <SmallText key={option.label} color={theme.token.colorTextTertiary}>
          {`${option.label}: ${get(accountDetails, option.key)}${
            index < viewOptions.length - 1 ? ' • ' : ''
          }`}
        </SmallText>
      ))}
    </Flex>
  );
});
